import { DateRange } from '@sandbox-platform/shared-ui';

import {
  CommissionInvoiceListFilters,
  CommissionInvoiceSearchDTO,
} from '../../../../types/commission-invoice.types';

export function encodeInvoiceSearchParams(
  currentPage: number,
  pageSize: number,
  dateRange: DateRange,
  filters: CommissionInvoiceListFilters,
  sortBy: string,
  sortDirection: 'asc' | 'desc'
): CommissionInvoiceSearchDTO {
  const searchParams: CommissionInvoiceSearchDTO = {
    page: currentPage,
    limit: pageSize,
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  if (dateRange.from) {
    searchParams.date_from =
      dateRange.from instanceof Date
        ? dateRange.from.toISOString()
        : dateRange.from;
  }

  if (dateRange.to) {
    searchParams.date_to =
      dateRange.to instanceof Date ? dateRange.to.toISOString() : dateRange.to;
  }

  if (filters.status !== 'all') {
    searchParams.status = filters.status;
  }

  if (filters.payeeType !== 'all') {
    searchParams.payee_type = filters.payeeType;
  }

  if (filters.payeeOrganization?.id) {
    searchParams.payee_organization_id = filters.payeeOrganization.id;
  }

  if (filters.payerOrganization?.id) {
    searchParams.invoice_recipient_organization_id =
      filters.payerOrganization.id;
  }

  return searchParams;
}
